import { apiV2 } from "../../api/api";
import type { BasketV2Response, CheckoutV2Request, CheckoutV2Response } from "../../types/types";

// Savatni do'kon bo'yicha guruhlangan holda oladi
export const getBasketV2 = async (): Promise<BasketV2Response> => {
  const response = await apiV2.get("/orders/basket/");
  return response.data;
};

// Bitta do'kon uchun checkout — faqat shu do'kon mahsulotlaridan buyurtma yaratadi
export const checkoutStore = async (
  storeId: number,
  data: CheckoutV2Request
): Promise<CheckoutV2Response> => {
  const response = await apiV2.post(`/orders/stores/${storeId}/checkout/`, data);
  return response.data;
};
